import { lazyVue } from "@/utils";
export default [{
    path: '/orderConfirm',
    name: 'orderConfirm',
    title: '确认订单',
    component: lazyVue('orderConfirm/index'),
    meta: {
        // showBar:1,
        title: '确认订单',
        name: '确认订单',
        isKeepAlive: true,
    }
}, {
    path: '/orderConfirm/diyTimeChoose',
    name: 'diyTimeChoose',
    title: '确认订单/时间选择',
    component: lazyVue('orderConfirm/components/diyTimeChoose'),
    meta: {
        // showBar:1,
        title: '确认订单/时间选择',
        name: '确认订单/时间选择'
    }
}]



// WEBPACK FOOTER //
// ./src/router/orderConfirm/index.js